import React from "react";
import { Navigate } from "react-router-dom";

export function PrivateRoute({ children }: any) {
  const deviceIp = localStorage.getItem("deviceIp");

  if (deviceIp) {
    return <Navigate to="/naoautorizado" />;
  }

  return children;
}
